import React from "react";
import fetchData from "../../../utils/api";
import { AccordionContent } from "../../../components/ui/accordion";
import { Button } from "../../../components/ui/button";
import FormError from "../../../components/FormError";
import DropDownList from "../../../components/DropDownList";
import { Label } from "../../../components/ui/label";
import { Icons } from "../../../components/icons";
import { Formik } from "formik";
import { TableReservationAvailableTimeChoiceFormValidation } from "./Validation";
import { useTranslation } from "react-i18next";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../../components/ui/popover";
import { cn } from "../../../lib/utils";
import { CalendarIcon } from "lucide-react";
import { format } from "date-fns";
import { Calendar } from "../../../components/ui/calendar";
import { SkeletonLoading } from "../../../components/Skeleton";

export default function TableReservationDateAndTime({
  cartList,
  authToken,
  id,
  restaurantDetail,
  handleCartList,
  handleAccordionClick,
}) {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [timeDropDownList, setTimeDropDownList] = React.useState<any>([]);
  const [dayDropDownList, setDayDropDownList] = React.useState<any>([]);
  const [selectedDayTime, setSelectedDayTime] = React.useState<any>("");
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  const handleFormattedDate = (date) => {
    const [day, month, year] = date.split("/").map(Number);
    const formattedYear = year < 100 ? 2000 + year : year; // Ensure correct century
    const formattedDate = new Date(formattedYear, month - 1, day); // Month is 0-based
    return formattedDate;
  };

  const handleTableReservationInfo = async () => {
    try {
      setIsLoading(true);
      const res = await fetchData({
        url: "cart/table-reservation-info",
        method: "POST",
        token: authToken,
      });
      if (res.status_code === 200) {
        setDayDropDownList(res.data?.table_reservation_days);
        setTimeDropDownList(res.data?.table_reservation_time);
        setSelectedDayTime(
          res.data?.table_reservation_time[
            res.data?.table_reservation_days[0]?.label
          ]
        );
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    handleTableReservationInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (
      timeDropDownList &&
      dayDropDownList &&
      cartList?.tableReservation?.date
    ) {
      const day: any = dayDropDownList.find(
        (c) => c.value === cartList?.tableReservation?.date
      )?.label;
      setSelectedDayTime(timeDropDownList[day]);
    }
  }, [timeDropDownList, dayDropDownList]);

  const { t } = useTranslation();

  return (
    <>
      {isLoading ? (
        <SkeletonLoading />
      ) : (
        <div>
          <Formik
            enableReinitialize={true}
            initialValues={{
              date: cartList?.tableReservation?.date
                ? handleFormattedDate(cartList?.tableReservation?.date)
                : dayDropDownList.length > 0
                ? undefined
                : undefined,
              time: cartList?.tableReservation?.time
                ? cartList?.tableReservation?.time
                : selectedDayTime[0]?.value,
            }}
            validationSchema={TableReservationAvailableTimeChoiceFormValidation}
            onSubmit={async (values: any) => {
              setIsLoading(true);
              const cachedCart = localStorage.getItem("cart");
              try {
                const filterDate = format(values.date, "dd/MM/yy");
                const body: any = {
                  cart_id: cachedCart,
                  date: filterDate,
                  time: values.time,
                };
                const res = await fetchData({
                  url: "cart/table-reservation",
                  method: "POST",
                  body,
                  token: authToken,
                });
                if (res.status_code === 200) {
                  setIsLoading(false);
                  handleCartList();
                  handleAccordionClick("item-5");
                }
              } catch (error) {
                console.log("error", error);
              }
            }}
          >
            {({ errors, touched, setFieldValue, values, handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <AccordionContent className="grid p-2 gap-2">
                  <div className="grid gap-2 w-full">
                    <Label className="text-left" htmlFor="date">
                      {t("cart.available_time_choice.form.date")}
                    </Label>
                    {/* <div>
                  <DropDownList
                    id="date"
                    label={t("cart.available_time_choice.form.date")}
                    data={dayDropDownList}
                    value={values.date}
                    defaultValue={
                      cartList?.tableReservation?.date
                        ? cartList?.tableReservation?.date
                        : dayDropDownList.length > 0
                        ? dayDropDownList[0]?.value
                        : ""
                    }
                    onValueChange={(e: any) => {
                      setFieldValue("date", e, true);
                      setFieldValue("time", "", true);

                      const day: any = dayDropDownList.find(
                        (c) => c.value === e
                      )?.label;
                      setSelectedDayTime(timeDropDownList[day]);
                    }}
                    disabled={isLoading}
                  />

                  {errors.date && touched.date ? (
                    <FormError msg={t(errors.date as string)} />
                  ) : null}
                </div> */}
                    <div>
                      <Popover open={isOpen} onOpenChange={setIsOpen}>
                        <PopoverTrigger asChild>
                          <Button
                            id="date"
                            variant={"outline"}
                            className={cn(
                              "w-full justify-start text-left font-normal",
                              !values.date && "text-muted-foreground"
                            )}
                          >
                            <CalendarIcon className="mr-2 h-4 w-4" />
                            {values.date ? (
                              <>{format(values.date, "cccc, MMMM do, yyyy")}</>
                            ) : (
                              <span>
                                {t("cart.available_time_choice.form.pick_date")}
                              </span>
                            )}
                          </Button>
                        </PopoverTrigger>
                        <PopoverContent className="w-auto p-0" align="start">
                          <Calendar
                            id="date"
                            fromDate={new Date()}
                            toDate={
                              new Date(
                                new Date().setMonth(
                                  new Date().getMonth() +
                                    (Number(
                                      restaurantDetail?.tableReservation
                                        ?.maximum_time_in_advance
                                    ) ?? 1)
                                )
                              )
                            }
                            initialFocus
                            mode="single"
                            selected={values.date}
                            disabled={(date) => {
                              const formattedDate = format(date, "dd/MM/yy");

                              const dateExists = dayDropDownList.some(
                                (day) => day.value === formattedDate
                              );

                              return !dateExists;
                            }}
                            onSelect={(date) => {
                              // Handle null/undefined case explicitly
                              if (!date) {
                                setFieldValue("date", "", true);
                                setFieldValue("time", "", true);
                                return;
                              }

                              // Ensure we're working with a Date object
                              const selectedDate = new Date(date);

                              // Update the form values
                              setFieldValue("date", selectedDate, true);
                              setFieldValue("time", "", true);

                              // Format the date for dropdown matching
                              const formattedValue = format(
                                selectedDate,
                                "dd/MM/yy"
                              );

                              // Find the corresponding day in the dropdown list
                              const day = dayDropDownList.find(
                                (c) => c.value === formattedValue
                              )?.label;

                              // Set the selected day time
                              if (day && timeDropDownList[day]) {
                                setSelectedDayTime(timeDropDownList[day]);
                              }
                              setIsOpen(false);
                            }}
                          />
                        </PopoverContent>
                      </Popover>
                      {errors.date && touched.date ? (
                        <FormError msg={t(errors.date as string)} />
                      ) : null}
                    </div>
                  </div>
                  <div className="grid gap-2 w-full">
                    <Label className="text-left" htmlFor="time">
                      {t("cart.available_time_choice.form.time")}
                    </Label>
                    <div>
                      <DropDownList
                        id="time"
                        label={t("cart.available_time_choice.form.time")}
                        placeholder={t(
                          "cart.available_time_choice.form.time_placeholder"
                        )}
                        defaultValue={
                          cartList?.tableReservation?.time
                            ? cartList?.tableReservation?.time
                            : selectedDayTime[0]?.value
                        }
                        data={selectedDayTime}
                        value={values.time}
                        onValueChange={(e: any) => {
                          setFieldValue("time", e, true);
                        }}
                        disabled={isLoading}
                        exceptTranslation={true}
                      />
                      {errors.time && touched.time ? (
                        <FormError msg={t(errors.time as string)} />
                      ) : null}
                    </div>
                  </div>
                  <div className="flex justify-end w-full">
                    <Button disabled={isLoading} type="submit">
                      {isLoading && (
                        <Icons.spinner className="mr-2 h-4 w-4 animate-spin" />
                      )}
                      {t("save")}
                    </Button>
                  </div>
                </AccordionContent>
              </form>
            )}
          </Formik>
        </div>
      )}
    </>
  );
}
